"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(_ref) {
  var media = _ref.media,
      src = _ref.src,
      href = _ref.href,
      coverColor = _ref.coverColor,
      noSampleClass = _ref.noSampleClass;
  return "\n<div class=\"CoverImageContainer\" style=\"background-color: ".concat(coverColor, "\">\n    <a href=\"").concat(href, "\"\n           tabindex=\"-1\"\n           data-href    =\"").concat(href, "\"\n           data-media-id=\"").concat(media.id, "\"\n           data-title   =\"").concat(media.title, "\"\n           data-type    =\"").concat(media.type.id, "\">\n        <img\n            tabindex=\"-1\"\n            aria-label=\"").concat(media.title, " - ").concat(html(media.type.id), "\"\n            tabindex=\"0\"\n            class=\"large-title js-details-cover-image ").concat(noSampleClass, "\"\n            src=\"").concat(src, "\"\n            srcset=\"").concat(src, "&dpr=2 2x,\n                    ").concat(src, "&dpr=1.5 1.5x,\n                    ").concat(src, " 1x\"\n            alt=\"").concat(media.title, " - ").concat(html(media.type.id), "\"\n            style=\"background-color: ").concat(coverColor, "; max-height: none !important;\"/>\n    </a>\n</div>");
};

exports["default"] = _default;